import "./styles.css"
import { useContext, useState } from "react";
import {
    MessageInput,
} from "@chatscope/chat-ui-kit-react";
import { RelevantDocs } from "../RelevantDocs";
import { ReactComponent as ChatIcon } from 'src/assets/icons/ic-chat.svg';
import { ReactComponent as ChevronRightIcon } from 'src/assets/icons/ic-right.svg';
import { SettingContext } from "src/context/settings";

export const WelcomeMsg = ({
    setIsFirstStep,
    onSend,
}) => {
    const [text, setText] = useState('');

    const { settings } = useContext(SettingContext);

    const handleSend = (message) => {
        setIsFirstStep(false);
        onSend(message);
      };

    const handleSubmit = () => {
        handleSend(text)
    }

    const widgetStyles = {
        container: {
            minWidth: '300px',
            maxWidth: '450px',
            fontFamily: 'Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif',
            backgroundColor: 'rgb(245, 247, 249)',
            boxSizing: 'border-box',
        },
        header: {
            backgroundColor: 'rgb(0, 104, 255)',
            fontSize: '22px',
            color: '#fff',
            // borderRadius: '8px 8px 0px 0px',
            letterSpacing: '0.02em',
            whiteSpace: 'normal',
            fontWeight: '600',
            lineHeight: '30px',
            padding: '12px 24px',
            height: '110px',
        },
        body: {
            // padding: '16px 16px 18px',
            backgroundColor: '#fff',
            boxShadow: 'rgba(18, 52, 77, 0.16) 0px 0px 2px 0px, rgba(18, 52, 77, 0.1) 0px 2px 12px 0px',
            // minHeight: '364px',
            position: 'relative',
            top: '-40px',
            margin: '0 15px',
            borderRadius: '8px',
            paddingBottom: '0',
            overflow: 'hidden auto',
        },
        title: {
            color: 'rgb(18, 52, 71)',
            padding: '16px 16px 28px',
            margin: '0',
            fontSize: '1rem',
            fontWeight: '700',
            borderBottom: '1px solid rgb(211, 211, 211)',
            background: 'linear-gradient(rgb(255, 255, 255) 0%, rgb(243, 244, 246) 100%)',
            borderRadius: '8px 8px 0px 0px',
        },
        input: {
            position: 'relative',
            top: '-25px',
            margin: '5px 15px',
        },
        p: {
            fontSize: '0.75rem',
            fontWeight: '500',
            lineHeight: '24px',
            color: 'rgba(7, 18, 40, 0.6)',
            marginBottom: '-4px',
        },
        docsBody: {
            margin: '0 16px -25px',
            paddingTop: '4px',
            position: 'relative',
            top: '-25px',
        },
        chatIcon: {
            position: 'absolute',
            right: '22px',
            top: '56px',
            cursor: 'pointer',
        },
        support: {
            backgroundColor: 'white',
            margin: '0px 15px 0px',
            fontWeight: '700',
            fontSize: '15px',
            padding: '15px',
            display: 'flex',
            justifyContent: 'space-between',
            boxShadow: 'rgba(18, 52, 77, 0.16) 0px 0px 2px 0px, rgba(18, 52, 77, 0.1) 0px 2px 12px 0px',
            borderRadius: '8px',
            position: 'relative',
            top: '-30px',
            cursor: 'pointer',
        },
    }

    return (
        <div style={widgetStyles.container}>
            <div style={widgetStyles.header}>{settings.header}</div>
            <div style={widgetStyles.body}>
                <h5 style={widgetStyles.title}>Bạn có câu hỏi?</h5>
                <MessageInput
                    style={widgetStyles.input}
                    placeholder="Tìm kiếm trợ giúp"
                    attachButton={false}
                    sendButton={false}
                    value={text}
                    onSend={(message) => handleSend(message)}
                    onChange={(target) =>  setText(target)}
                />
                <ChatIcon style={widgetStyles.chatIcon} onClick={handleSubmit}/>
                <div style={widgetStyles.docsBody}>
                    {/* <p style={widgetStyles.p}>Câu trả lời liên quan nhất</p> */}
                    <RelevantDocs relevantDocs={settings.relevantDocs} title={"Tài liệu hỗ trợ"}/>
                </div>
            </div>
            <div style = {widgetStyles.support} onClick={()=> window.open(settings.ticketSupport)}>
                <p style={{margin:'0'}}>Bạn cần hỗ trợ thêm vấn đề khác?</p>
                <ChevronRightIcon style={widgetStyles.chevIcon}/>
            </div>
        </div>
    );

};